import SCHEDULE_EVENTS from '@webapp-next/modules/schedule/events';

function tryEmit(event: string, payload?: object): void {
  if (!window.VueEventBus) {
    console.error('VueEventBus is not initialised');
    return;
  }
  window.VueEventBus.$emit(event, payload);
}

function refresh(): void {
  tryEmit(SCHEDULE_EVENTS.REFRESH);
}

function updateEmployee(id: number): void {
  tryEmit(SCHEDULE_EVENTS.UPDATE_EMPLOYEES, { id });
}

function updateEmployees(): void {
  tryEmit(SCHEDULE_EVENTS.UPDATE_EMPLOYEES);
}

function updateShifts(shiftIds: number[]): void {
  tryEmit(SCHEDULE_EVENTS.REFRESH_SHIFT, { ids: shiftIds });
  tryEmit(SCHEDULE_EVENTS.ADJUST_SHIFTS);
}

const schedule = { refresh, updateShifts, updateEmployee, updateEmployees };

export default schedule;
